//#region Imports
import React, { useState, useEffect } from "react";
import { StyleSheet, Platform, SafeAreaView } from "react-native";
import { useTheme } from "@react-navigation/native";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import { useTranslation } from "react-i18next";
import HRAdminClientProjectDetails from "../HRAdminClients/HRAdminClientProjectDetails";
import HRAdminClientDetails from "../HRAdminClients/HRAdminClientDetails";
//#endregion

const HRAdminPageClients = () => {
  //#region Const Definitions and UseRef and UseState
  const { t } = useTranslation();
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const [isLoading, setIsLoading] = useState(false);
  const [showClientDetailsScreen, setShowClientDetailsScreen] = useState(1);
  const [showClientProjectsScreen, setShowClientProjectsScreen] = useState(0);
  const [selectedClient, setSelectedClient] = useState([]);
  //#endregion

  //#region UseEffect
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem("isRefresh", "true");
        localStorage.setItem("lastVisitedScreen", "HRAdminPageClients");
      } catch (error) {
        console.log(error.message);
      }
    };
    if (Platform.OS === "web") {
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, []);
  //#endregion

  //#region Helpers

  //* if refreshed, get data from session storage,
  //* to show same page as before refresh
  const checkIfRefreshed = async () => {
    try {
      let isRefresh = localStorage.getItem("isRefresh");
      if (isRefresh === "true") {

      }
    } catch (error) {
      console.log(error);
    }
  };
  //#endregion

  const selectCleintProjectDetails = () => {
    setShowClientDetailsScreen(0);
    setShowClientProjectsScreen(1);
  }

  const selectClientsDetailsScreen = () => {
    setShowClientDetailsScreen(1);
    setShowClientProjectsScreen(0);
  }

  if (isLoading) {
    return (
      <SafeAreaView style={styles.main}>
        <CustomLabel value={t("common:loading")} type="ASSM" />
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.rowMain}>
      <SafeAreaView style={styles.main}>
        {showClientDetailsScreen ? <>
          <CustomLabel
            value={t('navigate:CD')}
            type='MINORTITLE'
          />
          <HRAdminClientDetails
            setSelectedClient={setSelectedClient}
            selectCleintProjectDetails={selectCleintProjectDetails}
          /></>

          : showClientProjectsScreen ?
            <HRAdminClientProjectDetails
              client={selectedClient}
              selectClientsDetailsScreen={selectClientsDetailsScreen}
            />
            : <></>
        }
      </SafeAreaView>
    </SafeAreaView >
  );
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      flex: 1,
      marginTop: 20,
    },
    rowMain: {
      flex: 1,
      flexDirection: 'row',
    },
  });

export default HRAdminPageClients;
